export default __webpack_public_path__ + "static/media/kids-dentist-consutory-mobile.1b139cd2.png";